import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { httpRequest } from '../common/network'
import { setConfigurations, setInfo } from './features/chat/chatSlice'
import {ChatConfigStore, ChatInfoStore} from './features/chat/definitions'
import { useAppSelector } from './hooks'
import useFocusSharedTabs from './useFocusSharedTabs'

const usePollingChatConfig = (): void => {
    const dispatch = useDispatch()
    const realm = useAppSelector((state) => state.realm.value)
    const authInfo = useAppSelector((state) => state.auth)

    const doPolling = useCallback((): void => {
        httpRequest({
            method: 'GET',
            path: 'help/chat_config_info',
            params: {
                realm: realm,
            },
            onSuccess: (response: {
                data: { config: ChatConfigStore; info: ChatInfoStore | null }
            }) => {
                dispatch(setConfigurations(response.data.config))
                dispatch(setInfo(response.data.info))
            },
        })
    }, [dispatch, realm, authInfo.isAuth, authInfo.companyId, authInfo.personId])

    useFocusSharedTabs(doPolling, 5 * 60 *1000)
}

export default usePollingChatConfig
